export default "../css/6119146d77f0e6f6559e700021fbe8d1.ttf";